import { RecruitingInvitationStatusEnum } from './schema/recruiting.schema'

/** Keep in sync with EPS recruiting invitation config. */
export const DEFAULT_RECRUITING_INVITATION_EXPIRY_DAYS = 7
export const MAX_RECRUITING_INVITATION_EXPIRY_DAYS = 14

/** Per-customer config key that gates Recruiting for HR client admins. */
export const RECRUITING_CLIENT_ADMIN_FLAG =
  'admin.recruiting.enable-for-client-admins'

export const RECRUITING_INVITATION_SORT_FIELDS = [
  'benefitEffectiveDate',
  'expiresAt',
] as const

export type RecruitingInvitationSortField =
  (typeof RECRUITING_INVITATION_SORT_FIELDS)[number]

export type RecruitingInvitationSortOrder = 'ASC' | 'DESC'

export const DEFAULT_RECRUITING_INVITATION_SORT: RecruitingInvitationSortField =
  'benefitEffectiveDate'

export const DEFAULT_RECRUITING_INVITATION_SORT_ORDER: RecruitingInvitationSortOrder =
  'DESC'

export const DEFAULT_RECRUITING_INVITATION_PAGE = 1
export const DEFAULT_RECRUITING_INVITATION_PAGE_SIZE = 10

export const INVITATION_STATUS_FILTER_ALL = 'all' as const

export type InvitationStatusFilterValue =
  | typeof INVITATION_STATUS_FILTER_ALL
  | RecruitingInvitationStatusEnum
